import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDIcon } from '@facet-wealth/design';
import { getBorderRadius } from 'Components/utils';
import { getThresholdColorMap } from 'Consts/thresholds';
import { useFundedThreshold } from 'Components/UI/roadmapExplorer/goalsAccordion/useFundedThreshold';

const useStyles = buildUseStyles('GoalIconWithThresholdIcon', (theme) => ({
  circle: {
    ...getBorderRadius(theme.radius.full, { all: true }),
    borderWidth: theme.spacing(0.5),
    borderStyle: 'solid',
    padding: theme.spacing(1),
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  thresholdIcon: {
    position: 'absolute',
    top: -14,
    right: -9,
    // We have to have a white background or else the circle around the icon will make the icon look funky by coloring in part of the icon
    backgroundColor: theme.palette.common.white,
    // Now that we have a white background though, we have a new problem - there's just a white square around this thing! Let's make it a circle:
    ...getBorderRadius(theme.radius.full, { all: true }),
    // There's still some whitespace though because the icon has some extra spacing to it, so we'll have to remove that spacing
    '& .FD-MuiSvgIcon-root': {
      marginLeft: -7,
      marginBottom: -7,
    },
  },
  ...(Object.fromEntries(Object.entries(getThresholdColorMap(theme)).map(([colorName, color]) => ([
    `circle${colorName}`,
    { borderColor: color },
  ])))),
  ...(Object.fromEntries(Object.entries(getThresholdColorMap(theme)).map(([colorName, color]) => ([
    `icon${colorName}`,
    {
      '& .FD-MuiSvgIcon-root': {
        color: `${color} !important`,
      },
    },
  ])))),
}));

export const GoalIconWithThresholdIcon = ({ resource }) => {
  const classes = useStyles();
  const { threshold } = useFundedThreshold(resource);
  const color = threshold.attr('color');
  return (
    <div className={classNames(classes.circle, classes[`circle${color}`])}>
      <div className={classNames(classes[`icon${color}`])}>
        <FDIcon icon={resource.attr('icon')} size="md" />
      </div>
      <div className={classNames(classes.thresholdIcon, classes[`icon${color}`])}>
        <FDIcon icon={threshold.attr('icon')} size="md" />
      </div>
    </div>
  );
};

GoalIconWithThresholdIcon.propTypes = {
  resource: PropTypes.object.isRequired,
};
